<section>

    <img src="assets/images/1-2.png" alt="Banner SSR" class="img-fluid w-100">

    <div class="container py-4">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="row  align-items-end">
                    <div class="col-12 text-center pb-5">
                        <h2 class="text-dark  p-3 d-inline-block">
                            <a href="/" class="text-decoration-none text-primary">Inicio</a> - ARISE
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row g-4 mb-5" id="motivacion">
        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Motivación</h3>
                <hr>
                <p>En la actualidad, a pesar del trabajo que se viene desarrollando conforme al respeto de los derechos
                    sexuales de niñas, niños y adolescentes, todavía existen cifras que demuestran lo contrario, tal
                    como lo
                    indica la Unicef que "más de un millón de niñas y adolescentes son víctimas de violencia sexual en
                    latinoamérica" (Infobae, 2017).</p>
            </div>
        </div>

        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="ratio ratio-16x9">
                <video controls poster="assets/images/ARISE.jpeg">
                    <source src="videos/arise/arise.mp4" type="video/mp4">
                </video>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row g-4 py-5" id="problematica">
        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Problemática</h3>
                <hr>
                <p>El trabajo que se realiza en los centros educativos de países en vías de desarrollo se enfoca
                    principalmente en materias de conocimiento general pero falta concientizar la importancia al respeto
                    del
                    espacio personal y corporal. La idea es brindar de una herramienta tecnológica educativa para que
                    los
                    estudiantes puedan conocer el respeto desde y hacia sus pares, así como conocer cuales son las
                    partes
                    del cuerpo que se deben respetar.</p>
            </div>
        </div>

        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="accordion" id="problematicaAccordion">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Problemática en estadísticas
                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                        data-bs-parent="#problematicaAccordion">
                        <div class="accordion-body">
                            <p>Las cifras con respecto al acoso y abuso sexual en Ecuador indican que "1 de cada 10
                                mujeres
                                de 15 años o más fue abusada sexualmente durante su infancia o adolescencia, el 9% fue
                                besada o su cuerpo fue tocado en contra de su voluntad, el 7% reporta que sus 'partes
                                íntimas' fueron tocadas sin su consentimiento, mientras que el 4% asegura que fueron
                                obligadas a desvestirse y mostrar las 'partes íntimas'" (CNII, 2018).</p>
                        </div>
                    </div>
                </div>

                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            Abuso sexual en el ámbito educativo
                        </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                        data-bs-parent="#problematicaAccordion">
                        <div class="accordion-body">
                            <p>Con respecto al abuso sexual en el ámbito educativo se conoce que de un total de 4854
                                denuncias de violencia sexual contra niñas, niños y adolescentes entre 2015 y 2017, 2673
                                están relacionadas en el ámbito educativo, de las cuales 1256 están relacionadas con
                                docentes y autoridades (CNII, 2018).</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="container py-2">
    <div class="row g-4 py-5" id="propuesta">
        <div class="col-12 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Propuesta</h3>
                <hr>
                <p>El asistente robótico consta de ocho áreas que involucran: Espacio personal, lateralidad, partes del
                    cuerpo, colores, emociones, normas, secuencias y números. Cada una de estas áreas están orientadas
                    al
                    aprendizaje de distancias, identificación y manejo de las partes simétricas del cuerpo,
                    reconocimiento
                    de: emociones básicas, secuencias rítmicas como aplausos, zapateos y el conteo de números del 0 al
                    20.
                    Las áreas de lateralidad, emociones, normas, secuencias y números son controladas desde una
                    aplicación
                    móvil y el que actúa será el asistente robótico, mientras que las áreas relacionadas con el espacio
                    personal, partes del cuerpo y colores tendrán que ser controladas principalmente desde el robot y la
                    aplicación será el medio de interacción con las acciones correspondientes.</p>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <!-- Imagen Fig.1 -->
    <div class="row mb-5">
        <div class="col-12 text-center">
            <img src="assets/images/Picture2Arise.png" alt="Simply Easy Learning" class="img-fluid"
                style="max-width: 800px;">
            <p class="mt-3"><strong>Fig.1</strong> Arquitectura general del sistema compuesto por sus procesos y modulos
                principales</p>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row g-4 pt-5 pb-lg-5" id="resultados">
        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="text-center">
                <img src="assets/images/resultArise.png" class="img-fluid" alt="Simply Easy Learning"
                    style="max-width: 400px;">
                <p class="mt-2"><strong>Fig.2</strong> Beneficiarios indirectos provincia Azuay - Ecuador.</p>
            </div>
        </div>

        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Resultados</h3>
                <hr>
                <p>Con la ayuda de una validación de encuesta realizada a 36 niñas entre los cinco y seis años de edad
                    de la
                    Escuela de Educación Básica Fiscomisional "Sor Teresa Valsé" de la ciudad de Cuenca, Azuay -
                    Ecuador; se
                    obtiene un valor de Alfa de Cronbach del 0,60 el cual representa una estadística "aceptable para
                    propósitos exploratorios" (Hernández Sampieri et al., 2014).</p>
            </div>

            <h4 class="mt-4">Población Beneficiaria Indirecta</h4>
            <p>A nivel de la provincia del Azuay podrían beneficiarse del proyecto un total de 99380 niñas entre cinco a
                quince años de edad. Si se toma en cuenta las provincias restantes, se tendría un total de 1.597.341
                niñas.
            </p>
        </div>
    </div>
</section>

<section class="container py-2">
    <!-- Beneficiarios -->
    <div class="row mb-5 justify-content-center">
        <div class="col-md-4 mb-4 animate__animated animate__fadeInUp">
            <div class="card h-100 border-0 shadow">
                <div class="card-body text-center p-4">
                    <h2 class="display-4 text-primary mb-3"><strong>34</strong></h2>
                    <img src="assets/images/a1.png" alt="Beneficiarios directos" class="img-fluid mb-3"
                        style="max-width: 150px;">
                    <h5 class="card-title"><strong>Beneficiarios Directos</strong></h5>
                </div>
            </div>
        </div>

        <div class="col-md-4 mb-4 animate__animated animate__fadeInUp">
            <div class="card h-100 border-0 shadow">
                <div class="card-body text-center p-4">
                    <h2 class="display-4 text-primary mb-3"><strong>1.597.341</strong></h2>
                    <img src="assets/images/a2.png" alt="Beneficiarios indirectos" class="img-fluid mb-3"
                        style="max-width: 150px;">
                    <h5 class="card-title"><strong>Beneficiarios Indirectos</strong></h5>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row g-4 justify-content-center">
        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <div id="colorlib-project">
                    <div class="container-fluid px-0">
                        <div class="row">
                            <div class="col-12 text-center colorlib-heading animate-box fadeInUp animated-fast">
                                <h3>Interacción con el asistente robótico</h3>
                                <p>Pruebas realizadas en la Unidad Educativa Fiscomisional "Sor Teresa Valsé" con niñas
                                    de
                                    cinco a seis años de edad en las áreas de cuidado personal y las partes del cuerpo.
                                </p>
                            </div>
                        </div>

                        <div class="row g-4">
                            <div class="col-md-4 animate-box fadeInUp animated-fast">
                                <div class="project-entry text-center">
                                    <img class="img-fluid" id="myImg" src="assets/images/fotosarise/1.png"
                                        style="max-width: 360px; width: 100%">
                                </div>
                            </div>

                            <div class="col-md-4 animate-box fadeInUp animated-fast">
                                <div class="project-entry text-center">
                                    <img class="img-fluid" id="myImg2" src="assets/images/fotosarise/2.png"
                                        style="max-width: 360px; width: 100%">
                                </div>
                            </div>

                            <div class="col-md-4 animate-box fadeInUp animated-fast">
                                <div class="project-entry text-center">
                                    <img class="img-fluid" id="myImg3" src="assets/images/fotosarise/3.png"
                                        style="max-width: 360px; width: 100%">
                                </div>
                            </div>

                            <div class="col-md-4 animate-box fadeInUp animated-fast">
                                <div class="project-entry text-center">
                                    <img class="img-fluid" id="myImg4" src="assets/images/fotosarise/4.png"
                                        style="max-width: 360px; width: 100%">
                                </div>
                            </div>

                            <div class="col-md-4 animate-box fadeInUp animated-fast">
                                <div class="project-entry text-center">
                                    <img class="img-fluid" id="myImg5" src="assets/images/fotosarise/5.png"
                                        style="max-width: 360px; width: 100%">
                                </div>
                            </div>

                            <div class="col-md-4 animate-box fadeInUp animated-fast">
                                <div class="project-entry text-center">
                                    <img class="img-fluid" id="myImg6" src="assets/images/fotosarise/6.png"
                                        style="max-width: 360px; width: 100%">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--
                <hr>
                <h4>Para desarrolladores:</h4>
                
                    <p>- Source code Expert System: <a href="http://arcadapp.com/unescossr/" target="_blank">: Acceder código</a></p>
                    -->
            </div>
        </div>
    </div>
</section>


<section class="container py-2">
    <!-- Equipo -->
    <div class="row mb-5" id="equipo">
        <div class="col-12 text-center mb-5 animate__animated animate__fadeInUp">
            <h2>Equipo</h2>
        </div>

        <!-- Fila 1 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/user.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Sor Rosa Castro</h3>
                    <p class="mb-1">Director of the "Sor Teresa Valsé School"</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/user.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Ximena Ramón</h3>
                    <p class="mb-1">Bachelor of Basic Education “Sor Teresa” Valsé School</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/user.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Liliana Matute</h3>
                    <p class="mb-1">Ingeniero en Sistemas</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/ncampos.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Nataly Campos Sarmiento</h3>
                    <p class="mb-1">Economista</p>
                    <p class="small"></p>
                </div>
            </div>
        </div>

        <!-- Fila 2 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/kpanama.png'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Karina Panamá Manzheda</h3>
                    <p class="mb-1">Ingeniero en Sistemas</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/fpesantez.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Fernando Pesántez Avilés</h3>
                    <p class="mb-1">Doctor of Pedagogy</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/vrobles.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Vladimir Robles Bykbaev</h3>
                    <p class="mb-1">Doctor PH.D</p>
                    <p class="small">Doctor en Tecnologías de la información y las comunicaciones.</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/elema.png'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Efren Lema Condo</h3>
                    <p class="mb-1">Ingeniero Electrónico</p>
                </div>
            </div>
        </div>

        <!-- Fila 3 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/user.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Carlos Contreras</h3>
                    <p class="mb-1">Ingeniero en Sistemas</p>
                </div>
            </div>
        </div>
    </div>
</section>